/**
 * Fortschritt und Gesundheit eines Projekts.
 *
 * Rein und ohne Dexie - bekommt die bereits geladenen Aufgaben.
 */
import type { Project, Task } from '@/domain/types';

export interface ProjectProgress {
  total: number;
  done: number;
  open: number;
  /** 0..1. Ein Projekt ohne Aufgaben steht bei 0, nicht bei 100 Prozent. */
  ratio: number;
}

export function projectProgress(tasks: Task[]): ProjectProgress {
  const total = tasks.length;
  const done = tasks.filter((t) => t.status === 'erledigt').length;
  return { total, done, open: total - done, ratio: total === 0 ? 0 : done / total };
}

/**
 * Hat das Projekt eine naechste Aktion?
 *
 * Die zentrale Frage aus GTD: ein Projekt ohne konkreten naechsten Schritt
 * bewegt sich nicht, egal wie viele Aufgaben darunter haengen. "Irgendwann"
 * und "wartet auf jemanden" zaehlen ausdruecklich NICHT - beides beschreibt,
 * dass gerade nichts zu tun ist.
 */
export function hasNextAction(tasks: Task[]): boolean {
  return tasks.some((t) => t.status === 'naechste' || t.status === 'geplant');
}

/**
 * Steckengeblieben: aktiv, aber ohne naechsten Schritt.
 *
 * Ein pausiertes oder abgeschlossenes Projekt braucht keinen - deshalb wird
 * nur `aktiv` geprueft. Sonst waere die Warnung Dauerzustand und damit
 * wertlos.
 */
export function isStuck(project: Project, tasks: Task[]): boolean {
  if (project.status !== 'aktiv') return false;
  const offen = tasks.filter((t) => t.status !== 'erledigt');
  return offen.length === 0 || !hasNextAction(offen);
}
